import React, { useEffect, useState, useCallback, useRef } from "react";
import AdminAppBar from "../../../components/adminComponents/AdminAppBar";
import CustomHeading from "../../../components/common/CustomHeading";
import {
  formatNumber,
  getIcons,
  getNumericValue,
} from "../../../components/Constant/Constant";
import CustomTable from "../../Custom/CustomTable";
import { FaMapLocationDot } from "react-icons/fa6";
import CustomModel from "../../../components/common/CustomModel";
import Images from "../../Constants/Images";
import ManualProperty from "./ManualProperty";
import { LuSquareDashedMousePointer } from "react-icons/lu";
import CustomSuccessModel from "../../Custom/CustomSuccessModel";
import AutoProperty from "./AutoProperty";
import AutoPopulateProperty from "./AutoPopulateProperty";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import ProspectPropertyService from "../../Service/ProspectPropertyService";
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";
import { mapLoaderConfig } from "../../../GeoLocationCompoents/Services/mapLoaderConfig";
import PropertiesSelectingModel from "../../PropertyTypeModel/PropertiesSelectingModel";
import RoughFilter from "../../RoughDraft/RoughFilter";
import ProspectPropertyFilter from "./ProspectPropertyFilter";
import { roleId, userRole, userUid } from "../../../utils/storage";
import CustomChip from "../../../components/common/CustomChip";

const PropertyProcurementPage = () => {
  const icons = getIcons();

  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [hasMoreLeads, setHasMoreLeads] = useState(false);
  const [selected, setSelected] = useState(null);

  const [toggle, setToggle] = useState(false);
  const [addVisiblity, setAddVisiblity] = useState(false);
  const [manualVisiblity, setManualVisiblity] = useState(false);
  const [successModel, setSuccessModel] = useState(false);
  const [autoVisiblity, setAutoVisiblity] = useState(false);
  const [autoPopulateVisiblity, setAutoPopulateVisiblity] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalLiveCount, setTotalLiveCount] = useState(0);
  const [dashBoardCount, setDashBoardCount] = useState({});
  const [isOpenPropertyTypeModel, setIsOpenPropertyTypeModel] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [mapData, setMapData] = useState([]);
  const { isLoaded } = useJsApiLoader(mapLoaderConfig);
  
  // Pagination cache to store API responses
  const [paginationCache, setPaginationCache] = useState(new Map());
  const [pageTokens, setPageTokens] = useState([""]);  // Array to store tokens for each page
  const [filterData, setFilterData] = useState({
    location: null,
    propertyType: null,
    propertySource: null,
    backendUser: null,
    startDate: '',
    endDate: ''
  });
  const [isRemovingFilter, setIsRemovingFilter] = useState(false);

  const fetchDashboardCount = async () => {
    try {
      const body = {
         role : userRole === "Backend" ? roleId : null,
         userId : userUid,
      }
      const response = await ProspectPropertyService.getDashboardCounts(body);

      setDashBoardCount(response?.data?.data || {});
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDashboardCount();
  }, []);

  const LeadDashboradCount = [
    {
      label: "All Property",
      count: dashBoardCount?.allProperties || 0,
      bgColor: "bg-[#D3EEFF]",
      icon: icons?.AllLeadIcon,
    },
    {
      label: "Info Collection & Assignment",
      count: dashBoardCount?.infoCollectionAssignment || 0,
      bgColor: "bg-[#D3EEFF]",
      icon: icons?.AllLeadIcon,
    },
    {
      label: "Analysis",
      count: dashBoardCount?.legalAnalysis || 0,
      bgColor: "bg-[#EBEBFF]",
      icon: icons?.Unassigned,
    },
    {
      label: "Presentation Preparation",
      count: dashBoardCount?.presentationProperties || 0,
      bgColor: "bg-[#77C1A0]",
      icon: icons?.FollowUp,
    },
    {
      label: "Confirm List",
      count: dashBoardCount?.confirmedList || 0,
      bgColor: "bg-[#4BD196]",
      icon: icons?.Dealing,
    },
    {
      label: "Dropped",
      count: dashBoardCount?.dropped || 0,
      bgColor: "bg-[#E0AA9C]",
      icon: icons?.Unanswered,
    },
  ];
  const fetchMapData = async () => {
    try {
      const response =
        await ProspectPropertyService.getProspectPropertyGeoData();
      setMapData(response?.data?.geoPoints || []);
    } catch (error) {
      console.error("Error fetching map data:", error);
    }
  };
  useEffect(() => {
    fetchMapData();
  }, []);

  const isFirstRender = useRef(true);

  // Separate useEffect for search and pagination changes only
  useEffect(() => {
    let delayTimer;

    const triggerFetch = () => {
      setCurrentPage(1);
      clearPaginationCache();
      fetchData("next", "", 1, filterData);
    };

    // Skip duplicate call on very first render
    if (isFirstRender.current) {
      isFirstRender.current = false;
      triggerFetch(); // call only once at initial load
      return;
    }

    // Only trigger for search query and page size changes
    if (searchQuery.length === 0 || searchQuery.length > 2) {
      delayTimer = setTimeout(() => {
        triggerFetch();
      }, 600);
    }

    return () => {
      if (delayTimer) clearTimeout(delayTimer);
    };
  }, [searchQuery, pageSize]); // Removed filterData from dependency array

  // Function to clear pagination cache
  const clearPaginationCache = () => {
    setPaginationCache(new Map());
    setPageTokens([""]);
  };

  // Function to create cache key
  const createCacheKey = (page, filters, search, size) => {
    return JSON.stringify({
      page,
      search,
      size,
      location: filters.location?.value || null,
      propertyType: filters.propertyType?.value || null,
      propertySource: filters.propertySource?.value || null,
      backendUser: filters.backendUser?.value || null,
      startDate: filters.startDate,
      endDate: filters.endDate
    });
  };

  const fetchData = async (direction = "next", cursor = "", page = 1, filters = {}) => {
    setLoading(true);
    
    // Create cache key for current request
    const cacheKey = createCacheKey(page, filters, searchQuery, pageSize);
    
    // Check if data exists in cache for previous page navigation
    if (direction === "previous" && paginationCache.has(cacheKey)) {
      const cachedData = paginationCache.get(cacheKey);
      setData(cachedData.data);
      setTotalRecords(cachedData.totalRecords);
      setNextPageToken(cachedData.nextPageToken);
      setPrevPageToken(cachedData.prevPageToken);
      setHasMoreLeads(cachedData.hasMoreLeads);
      setTotalLiveCount(cachedData.totalLiveCount);
      setLoading(false);
      return;
    }
    
    try {
      const body = {
        isRoughDraft: false,
        searchKey: searchQuery,
        limit: pageSize,
        status: filters.propertyType?.value || "",
        sourcedBy: filters.propertySource ? filters.propertySource.value : null,
        location: filters.location ? filters.location.value : null,
        backendUser: filters.backendUser ? filters.backendUser.value : "",
        startAfter :cursor,
        direction,
      };
      const response = await ProspectPropertyService.getProspectProperties(
        body
      );
      
      const responseData = response?.data;
      const fetchedData = {
        data: responseData?.properties || [],
        totalRecords: responseData?.totalRecords || 0,
        nextPageToken: responseData?.pagination?.lastDocId || null,
        prevPageToken: responseData?.pagination?.firstDocId || null,
        hasMoreLeads: responseData?.pagination?.hasMore,
        totalLiveCount: responseData?.totalCount || 0
      };
      
      // Update state
      setTotalLiveCount(fetchedData.totalLiveCount);
      setData(fetchedData.data);
      setTotalRecords(fetchedData.totalRecords);
      setNextPageToken(fetchedData.nextPageToken);
      setPrevPageToken(fetchedData.prevPageToken);
      setHasMoreLeads(fetchedData.hasMoreLeads);
      
      // Cache the response for future use
      setPaginationCache(prev => {
        const newCache = new Map(prev);
        newCache.set(cacheKey, fetchedData);
        return newCache;
      });
      
      // Update page tokens array for navigation
      if (direction === "next" && fetchedData.nextPageToken) {
        setPageTokens(prev => {
          const newTokens = [...prev];
          if (newTokens.length <= page) {
            newTokens[page] = fetchedData.nextPageToken;
          }
          return newTokens;
        });
      }
      
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchLead = () => {
    setCurrentPage(1);
    clearPaginationCache(); // Clear cache when searching
    fetchData("next", "", 1, filterData);
  };

  const handlePageChange = (token, direction) => {
    if (direction === "size") {
      setPageSize(Number(token));
      setCurrentPage(1);
      clearPaginationCache(); // Clear cache when page size changes
      fetchData("next", "", 1, filterData);
    } else if (direction === "next") {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      fetchData("next", token, nextPage, filterData);
    } else if (direction === "previous") {
      const prevPage = Math.max(currentPage - 1, 1);
      setCurrentPage(prevPage);
      
      // Use the appropriate token for the previous page
      const prevToken = pageTokens[prevPage - 1] || "";
      fetchData("previous", prevToken, prevPage, filterData);
    }
  };

  const handlePropertyInfo = (record) => {
    navigate("/propertyprocurement-list-info", {
      state: {
        propertyName: record.name,
        propertyId: record.id,
        propertyTypeName: record.propertyType ? record.propertyType.name : "",
        propertyStage: record.stage ? record.stage : "",
        selectedPropertyData: record,
      },
    });
  };

  const columns = [
    {
      key: "propertyEnteredDate",
      title: "Property Came Date",
      render: (_, record) => (
        <div onClick={() => handlePropertyInfo(record)} className="text-center">
          <div>{record?.propertyEnteredDate}</div>
          {record?.propertyEnteredDaysAgo !== null && (
            <div className="text-xs bg-orange-50 border border-orange-500 rounded-full text-gray-500 px-2 inline-block">
              {record?.propertyEnteredDaysAgo}{" "}
              {record?.propertyEnteredDaysAgo > 1 ? "Days" : "Day"}
            </div>
          )}
        </div>
      ),
    },
    {
      key: "propertyId",
      title: "Property ID",
      dataIndex: "propertyId",
      render: (text, record) => (
        <div onClick={() => handlePropertyInfo(record)} className="text-center">
          {text || "N/A"}
        </div>
      ),
    },
    {
      key: "name",
      title: "Property Name",
      render: (text, record) => (
        <div
          onClick={() => handlePropertyInfo(record)}
          className="text-blue-500 capitalize line-clamp-2 text-wrap truncate cursor-pointer text-center"
        >
          {record?.name}
        </div>
      ),
    },
    {
      key: "unitCount",
      title: "No. of Units",
      render: (text, record) => (
        <div className="text-center">{record?.unitCount || 0}</div>
      ),
    },
    {
      key: "overAllArea",
      title: "Overall Sq feet",
      render: (_, record) => (
        <div className="text-center flex flex-col">
          <div>{record?.overAllArea ? `${record?.overAllArea}` : "N/A"}</div>
          <div className="text-sm">
            {" "}
            {record?.propertyType ? ` (${record?.propertyType?.name})` : ""}
          </div>
        </div>
      ),
    },
    {
      key: "location",
      title: "Location",
      render: (_, record) => (
        <div className="flex flex-col items-center">
         <div className="text-center">{record?.location?.name || "N/A"}</div>
         {record?.locationLatitude != null &&
            record?.locationLongitude != null && (
              <button
                onClick={() => {
                  setToggle(true);
                  setSelected({
                    ...record,
                    coordinates: `${record.locationLatitude},${record.locationLongitude}`,
                  });
                  const mapElement = document.querySelector(".map-container");
                  if (mapElement) {
                    mapElement.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className="text-xs w-fit bg-blue-100 text-blue-600 px-2 py-1 rounded-full mt-1 hover:bg-blue-200 transition-colors"
              >
                View on Map
              </button>
            )}
        </div>
       
      ),
    },
    {
      key: "propertyType",
      title: "Property Sourced By",
      render: (_, record) => (
        <div className="text-center flex flex-col text-sm">
          <div>{record?.primarySourcedBy?.name || ""}</div>
          <div>{record?.secondarySourcedBy?.name || "N/A"}</div>
        </div>
      ),
    },
    {
      key: "prospectStatus",
      title: "Current stage",
      render: (_, record) => (
       <div className="text-center">
          <div className="text-sm">{record?.prospectStatus}</div>
          {record?.propertyEnteredDaysAgo !== null && (
            <div className="text-xs bg-blue-50 border border-blue-500 rounded-full text-gray-500 px-2 inline-block">
              {record?.statusDaysAgo}{" "}
              {record?.statusDaysAgo > 1 ? "Days" : "Day"}
            </div>
          )}
        </div>
      )
        
    },
    {
      key: "analysisSummary",
      title: (
        <div className="flex flex-col items-center">
          <div className="font-semibold text-gray-800">Analysis Summary</div>
          <div className="flex justify-center gap-4 text-sm mt-1">
            <div className="flex items-center gap-1">
              <span className="w-3 h-3 rounded-full bg-orange-400 inline-block"></span>
              Pending
            </div>
            <div className="flex items-center gap-1">
              <span className="w-3 h-3 rounded-full bg-green-500 inline-block"></span>
              Completed
            </div>
          </div>
        </div>
      ),
      render: (_, record) => {
        const getCircle = (status) => {
          if (status === "Completed" || status === true) {
            return (
              <span className="w-6 h-6 rounded-full bg-green-500 inline-block border-2 border-gray-200"></span>
            );
          } else if (status === "Pending" || status === false) {
            return (
              <span className="w-6 h-6 rounded-full bg-orange-400 inline-block border-2 border-gray-200"></span>
            );
          }
          return (
            <span className="w-6 h-6 rounded-full bg-gray-400 inline-block border-2 border-gray-200"></span>
          );
        };

        return (
          <div className="text-center">
            {/* Circles with labels */}
            <div className="grid grid-cols-3 gap-y-6 justify-items-center">
              <div className="flex flex-col items-center">
                {getCircle(record?.isAdvocateAnalysisCompleted)}
                <span className="text-xs mt-1">Advocate</span>
              </div>

              <div className="flex flex-col items-center">
                {getCircle(record?.isVaoAnalysisCompleted)}
                <span className="text-xs mt-1">VAO</span>
              </div>

              <div className="flex flex-col items-center">
                {getCircle(record?.isSroAnalysisCompleted)}
                <span className="text-xs mt-1">SRO</span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-y-6 justify-items-center">
              <div className="flex flex-col items-center">
                {getCircle(record?.isPhysicalInspectionCompleted)}
                <span className="text-xs mt-1">Physical Insp</span>
              </div>

              <div className="flex flex-col items-center">
                {getCircle(record?.isGeneralAnalysisCompleted)}
                <span className="text-xs mt-1">Other</span>
              </div>
            </div>
          </div>
        );
      },
    },
  ];

  const handleSaveProperty = () => {
    setManualVisiblity(false);
    setSuccessModel(true);
  };

  const handleSaveAutoProperty = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setAutoVisiblity(false);
      setManualVisiblity(false);
      setAddVisiblity(false);
      setAutoPopulateVisiblity(true);
    }, 4000);
  };

  const handleRemove = (key) => {
    // Prevent multiple rapid calls
    if (isRemovingFilter) return;
    
    setIsRemovingFilter(true);
    
    const newFilterData = { ...filterData };
    
    if (key === "location") {
      newFilterData.location = null;
    } else if (key === "propertyType") {
      newFilterData.propertyType = null;
    } else if (key === "propertySource") {
      newFilterData.propertySource = null;
    } else if (key === "backendUser") {
      newFilterData.backendUser = null;
    } else if (key === "dateRange") {
      newFilterData.startDate = '';
      newFilterData.endDate = '';
    }
    
    // Update filter data and clear cache once
    setFilterData(newFilterData);
    setCurrentPage(1);
    clearPaginationCache();
    
    // Fetch data with new filters and reset the flag
    fetchData("next", "", 1, newFilterData).finally(() => {
      setIsRemovingFilter(false);
    });
  };

  const center = {
    lat: 12.97,
    lng: 80.15,
  };
  return (
    <div className="min-h-screen bg-appGrayBackground pb-10">
      <Header />
      <div className="pt-28 px-6 ">
        <div className="flex items-center justify-between">
          <CustomHeading
            title={`Property Procurement List : (Live ${totalLiveCount})`}
          />
          <button
            // onClick={() => {
            //   navigate("/propertyprocurement-list/property-info");
            // }}
            onClick={() => setIsOpenPropertyTypeModel(true)}
            className="text-white text-center p-3 font-medium rounded-[10px] bg-customGreen"
          >
            Add Prospect Property
          </button>
        </div>

        {/* Dashboard Cards */}
        <div className="grid grid-cols-4 mt-4 xl:grid-cols-7 gap-4 pt-[36px] pb-[28px]">
          {LeadDashboradCount.map((item, index) => (
            <div key={index} className="w-full flip-card">
              <div className="cursor-pointer rounded-2xl h-full min-h-[120px]">
                <div
                  className={`${item?.bgColor} flip-card-front rounded-2xl p-4 h-full flex flex-col justify-between`}
                >
                  <div className="text-xl font-medium mb-2">
                    {formatNumber(getNumericValue(item?.count))}
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-[15px] font-medium">{item?.label}</div>
                    {/* {item?.icon && (
                      <img
                        src={item.icon}
                        alt="icon"
                        className="w-[25px] h-[30px]"
                      />
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mb-4">
          {(filterData.location || filterData.propertyType || filterData.propertySource || filterData.backendUser || (filterData.startDate && filterData.endDate)) && (
            <div className="flex items-center gap-3 flex-wrap">
              <span className="text-sm font-medium text-gray-700">Applied Filters:</span>
              
              {filterData.location && (
                <CustomChip
                  value={filterData.location.label}
                  onRemove={() => handleRemove("location")}
                />
              )}
              
              {filterData.propertyType && (
                <CustomChip
                  value={filterData.propertyType.label}
                  onRemove={() => handleRemove("propertyType")}
                />
              )}
              
              {filterData.propertySource && (
                <CustomChip
                  value={filterData.propertySource.label}
                  onRemove={() => handleRemove("propertySource")}
                />
              )}

              {filterData.backendUser && (
                <CustomChip
                  value={filterData.backendUser.label}
                  onRemove={() => handleRemove("backendUser")}
                />
              )}
              
              {filterData.startDate && filterData.endDate && (
                <CustomChip
                  value={`Date: ${filterData.startDate} to ${filterData.endDate}`}
                  onRemove={() => handleRemove("dateRange")}
                />
              )}
            </div>
          )}
        </div>

        {/* Property Table */}
        <CustomTable
          disPlay={false}
          columns={columns}
          data={data}
          placeholder={"Search Property Name..."}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          handleSearchLead={handleSearchLead}
          loading={loading}
           isFilter={toggle ? false : true}
          pagination={true}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          pageSize={pageSize}
          totalRecords={totalRecords}
          nextPageToken={nextPageToken}
          prevPageToken={prevPageToken}
          hasMoreLeads={hasMoreLeads}
          handleFilter={() => setFilterOpen(true)}
          setToggel={setToggle}
          toggel={toggle}
          children={
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6 p-3 w-full">
              {/* Interactive Google Map */}

              <div className="h-[500px] rounded-md overflow-hidden border col-span-8">
                {!isLoaded ? (
                  <div className="flex items-center justify-center h-full">
                    Loading map...
                  </div>
                ) : (
                  <GoogleMap
                    mapContainerStyle={{ width: "100%", height: "100%" }}
                    center={center}
                    zoom={11}
                  >
                    {mapData.map((property) => {
                      const [lat, lng] = property.coordinates
                        .split(",")
                        .map(Number);
                      return (
                        <Marker
                          key={property.id}
                          position={{ lat, lng }}
                          onMouseOver={() => setSelected(property)}
                          onClick={() => setSelected(property)}
                        />
                      );
                    })}

                    {selected && (
                      <InfoWindow
                        position={{
                          lat: parseFloat(selected.coordinates.split(",")[0]),
                          lng: parseFloat(selected.coordinates.split(",")[1]),
                        }}
                        onCloseClick={() => setSelected(null)}
                      >
                        <div className="p-2">
                          <h4 className="font-bold">{selected.name}</h4>
                          <p>Sq.Ft: {selected.overallArea}</p>
                          <p>Location: {selected.location}</p>
                        </div>
                      </InfoWindow>
                    )}
                  </GoogleMap>
                )}
              </div>
              {/* Property List */}
              <div className="col-span-4 h-[500px] rounded-md overflow-y-auto p-1">
                {mapData.map((list) => (
                  <div
                    key={list.id}
                    className="p-3 mb-3 border border-slate-200 rounded-md cursor-pointer hover:bg-gray-50"
                    onClick={() => setSelected(list)}
                  >
                    <div className="flex flex-col gap-2">
                      <div className="text-blue-500 text-[16px] capitalize truncate cursor-pointer">
                        {list?.name}
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="text-[12px]">
                          Overall Sq.Ft: {list?.overallArea}
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <FaMapLocationDot className="text-customGreen" />
                        <div className="text-[12px]">
                          Location: {list?.location}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          }
        />
      </div>
      <CustomModel
        isOpen={addVisiblity}
        isClose={() => {
          setAddVisiblity(false);
        }}
        title={"Add  Prospect Property"}
        content={
          <div className="flex items-center gap-6 ">
            <div
              onClick={() => {
                setAddVisiblity(false);
                setManualVisiblity(true);
              }}
              className="bg-slate-100 border cursor-pointer hover:border hover:bg-green-100 hover:border-green-500  w-full p-3 rounded-[10px]"
            >
              <div className="flex items-center gap-3">
                <img src={Images.ManualIcon} />
                <div>Manual Upload</div>
              </div>
            </div>
            <div
              onClick={() => {
                setAutoVisiblity(true);
              }}
              className="bg-slate-100 border cursor-pointer hover:border hover:bg-green-100 hover:border-green-500  w-full p-3 rounded-[10px]"
            >
              <div className="flex items-center gap-3">
                <img src={Images.AutoIcon} />
                <div>Auto Upload</div>
              </div>
            </div>
          </div>
        }
      />

      <ManualProperty
        isSliderOpen={manualVisiblity}
        onHide={() => {
          setManualVisiblity(false);
        }}
        handleSave={handleSaveProperty}
      />

      <AutoProperty
        isOpen={autoVisiblity}
        onClose={() => {
          setAutoVisiblity(false);
        }}
        loading={loading}
        onSubmit={handleSaveAutoProperty}
      />

      <AutoPopulateProperty
        isOpen={autoPopulateVisiblity}
        onClose={() => {
          setAutoPopulateVisiblity(false);
        }}
      />
      <ProspectPropertyFilter
        isOpen={filterOpen}
        onClose={() => setFilterOpen(false)}
        currentFilters={filterData}
        onApplyFilters={(filters) => {
          setFilterData(filters);
          setCurrentPage(1);
          clearPaginationCache();
          fetchData("next", "", 1, filters);
        }}
      />

      <PropertiesSelectingModel
        isOpen={isOpenPropertyTypeModel}
        close={() => setIsOpenPropertyTypeModel(false)}
        accessType={"Prospect"}
      />

      <CustomSuccessModel
        isOpen={successModel}
        onClose={() => {
          setSuccessModel(false);
        }}
        title={"Property Added Successfully"}
      />
    </div>
  );
};

export default PropertyProcurementPage;
